
import g1 from '../images/gallary/1.jpg'
import g2 from '../images/gallary/2.jpg'
import g3 from '../images/gallary/3.jpg'
import g4 from '../images/gallary/4.jpg'
import g5 from '../images/gallary/5.jpg'
import g6 from '../images/gallary/6.jpg'

export const GalleryImgs  = [

    {
        imgID:1,
        imgSrc:g1
    },
    {
        imgID:1,
        imgSrc:g2
    },
    {
        imgID:1,
        imgSrc:g3
    },
    {
        imgID:1,
        imgSrc:g4
    },
    {
        imgID:1,
        imgSrc:g5
    },
    {
        imgID:1,
        imgSrc:g6
    },
]